import { render, staticRenderFns } from "./CustomerSettingsView.vue?vue&type=template&id=3d8221fe&scoped=true&"
import script from "./CustomerSettingsView.vue?vue&type=script&lang=ts&"
export * from "./CustomerSettingsView.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerSettingsView.vue?vue&type=style&index=0&id=3d8221fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8221fe",
  null
  
)

export default component.exports